'use strict';

export const Constants = Object.freeze({
  RECONCILATION_TABS: [
    {
      title: 'RECONCILIATION',
      active: true,
    },
    {
      title: 'CLOSED RECONCILIATION',
      active: false,
    },
  ],
  OPERATION_TYPES: {
    MANUAL_FIX: 'MF',
    CLOSED: 'RECON',
    LIVE: 'LIVE_RECONCILIATION',
  },
  LIVE_RECO_STATUS_OPTIONS: {
    COMPLETES: 21,
    REJECT: 33,
    ACCEPT: 0,
  },
});
